import { isPlatformBrowser } from '@angular/common';
import { Component, inject, input, PLATFORM_ID, signal, AfterViewInit } from '@angular/core';
declare let googletag: any;
@Component({
  selector: 'app-advertise',
  imports: [],
  templateUrl: './advertise.html',
})
export class Advertise implements AfterViewInit {
  private platformId = inject(PLATFORM_ID)
  readonly adId = input<string>('')
  readonly slotName = input<string>('')
  readonly sizes = input<number[][]>([])

  readonly isBrowser = signal(isPlatformBrowser(this.platformId))

  width = signal(0); 
  height = signal(0); 

  ngAfterViewInit() {
    if(this.isBrowser()){
      if (!this.slotName() || this.sizes().length === 0) {
        return;
      }
  
      googletag.cmd.push(() => {
        const slot = googletag.defineSlot(this.slotName(), this.sizes(), this.adId())
          .addService(googletag.pubads());
  
        if (this.sizes().length > 0) {
          this.width.set(this.sizes()[0][0]);
          this.height.set(this.sizes()[0][1]);
        }
  
        googletag.enableServices();
        googletag.display(this.adId());
      });
    }
    
  }
}
